import {Component, Input, OnInit} from '@angular/core';
import {DataEntryCollection} from './model/data-entry-collection';
import {HttpService} from '../../../../services/http.service';


@Component({
  selector: 'app-map-chart',
  templateUrl: './map-chart.component.html',
  styleUrls: ['./map-chart.component.scss']
})

export class MapChartComponent implements OnInit {

  public collection : DataEntryCollection;

  protected sizeConst = 3; // Will be multiplied by sizeMod when pop is generated

  @Input() width : string;
  @Input() height : string;

  constructor(private http: HttpService) {
      this.collection = new DataEntryCollection();
  }

  ngOnInit() {

      this.http.LocationGraphData().subscribe(locations => {
        locations.forEach((obj) => {
            this.collection.addObject(obj.country, obj.value);
        })
      });

  }

}



// WEBPACK FOOTER //
// ./src/app/components/charts/chart/map-chart/map-chart.component.ts